import React from 'react';
import styled, { keyframes } from 'styled-components';

// Keyframes for the gradient animation
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

// Styled component for the skeleton loader
const EntityLoaderBox = styled.div`
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-top: ${({ theme }) => theme.spacing.l};
`;
const EntitySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const EntityLoader = () => {
  return (
    <EntitySection>
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
      <EntityLoaderBox />
    </EntitySection>
  );
};

export default EntityLoader;
